// extracted by mini-css-extract-plugin
export default {"options-column":"style_options-column__vsPTr__WHx6O","options-btn":"style_options-btn__U3uoy__WHx6O","tooltip":"style_tooltip__vJlkv__WHx6O"};